import { combineReducers } from "redux";
import authApp from "./auth/reducer";
import importLogApp from "./importLog/reducer";
import blobSettingApp from "./blobSetting/reducer";
import logApp from "./log/reducer";
import syncLogApp from "./syncLog/reducer";
import entraLogApp from "./entraLog/reducer";
import settingApp from "./setting/reducer";
import entraSyncApp from "./entraSync/reducer";
import gwsSyncApp from "./gwsSync/reducer";
import rosterImportApp from "./rosterImport/reducer";
import oauthKeyApp from "./oauthKey/reducer";
import recoveryLogApp from "./recoveryLog/reducer";

export default combineReducers({
  authApp,  
  importLogApp,
  blobSettingApp,
  logApp,
  syncLogApp,
  entraLogApp,
  settingApp,
  entraSyncApp,
  gwsSyncApp,
  rosterImportApp,
  oauthKeyApp,
  recoveryLogApp,
});
